// MyComponent.jsx

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faCoffee } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp, faFacebookMessenger } from '@fortawesome/free-brands-svg-icons';
import './Whats.css'; // Import the CSS file

const MyComponent = () => {
    return (
        <div className="container5">
            <a href="https://wa.me/+972545717774" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faWhatsapp} className="icon" />
            </a>

            <a href="https://www.facebook.com/profile.php?id=61561107336387" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFacebookMessenger} className="icon" />
            </a>


            <a href="mailto:boulosghada@gmail.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faEnvelope} className="icon" />
            </a>
            <h5 id='Pow'>This Card was powered by Hmnny</h5>

            {/* Add more email icons or other components as needed */}
        </div>

    );
};

export default MyComponent;
